import React, { useState } from "react";
import { Button } from "grommet";

const ConfirmButton = ({ label, onClick, ...rest }: { label: string; onClick: () => void; [key: string]: any }) => {
    const [confirm, setConfirm] = useState(false);

    const handleClick = () => {
        if (confirm) {
            onClick();
            setConfirm(false);
        } else {
            setConfirm(true);
        }
    };

    const handleBlur = () => {
        setConfirm(false);
    };

    return <Button primary={confirm} label={confirm ? `Confirm ${label}` : label} onClick={handleClick} onBlur={handleBlur} {...rest} />;
};

export default ConfirmButton;
